const mutations = {
    NEED_IDS (state, ids) {
        const { needEditScoreTypeIds = [], needEntryWritePrject = [] } = ids || {}
        state.needIds = needEditScoreTypeIds
        state.needEntryWritePrject = needEntryWritePrject
    }
}

export default {
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/needIds.js